import { ChangeDetectorRef, Component , ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Optional, Output, Renderer2, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import config from 'config/default.json';

@Component({
  selector: 'app-setting-promotion',
  templateUrl: './setting-promotion.component.html',
  styleUrls: ['./setting-promotion.component.scss']
})
export class SettingPromotionComponent implements OnInit{
  constructor(
    private apiService: ApiServiceModule,
    private helper: HelperModule,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    @Optional() public dialogRef: MatDialogRef<SettingPromotionComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {}


  @Input() rowInfos: { [x:string]: any } = new Map();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() productData: any[] = [];
  @Input() promoterData: any[] = [];
  @Input() platformInfos: { [x:string]: any } = new Map();
  @Input() action: string = '';
  @Output() updatePromotion = new EventEmitter<any>();

  promoNameControl = new FormControl();
  productControl = new FormControl();
  priceControl = new FormControl();
  priceRateControl = new FormControl();
  typeControl = new FormControl();
  durationControl = new FormControl();
  beginDateControl = new FormControl();
  expirationDateControl = new FormControl();
  activeControl = new FormControl();
  isDefaultPromo: boolean = false;

  promoterRateControl = new FormControl();
  sendEmailControl = new FormControl();

  promoterControl = new FormControl();
  
  promoType = '';
  studentPayment = 0;
  promoterPayout = 0;
  enovskyGain = 0;
  promoCode = '';
  priceProduct = 0;
  priceRate = 0;
  promoterRate = 0;
  inProgress = false;

  ngOnInit(){
    if (this.data) {
      this.action = this.data.action || '';
      this.productData = this.data.product || [];
      this.promoterData = this.data.promoter || [];
      this.rowInfos = this.data.row_infos || {};
      this.userInfos = this.data.user_infos || {};
      this.platformInfos = this.data.platform_infos || {};
    }
    if(this.action == 'update_promo'){
      this.promoNameControl.setValue(this.rowInfos['promo_name']);
      this.productControl.setValue(this.rowInfos['id_product']);
      this.priceControl.setValue(this.rowInfos['student_price']);
      this.priceRateControl.setValue(this.rowInfos['price_rate_discount']);
      this.typeControl.setValue(this.rowInfos['promo_type']);
      this.promoType = this.rowInfos['promo_type'];
      this.durationControl.setValue(this.rowInfos['duration']);
      this.beginDateControl.setValue(this.rowInfos['begin_date']);
      this.expirationDateControl.setValue(this.rowInfos['expiration_date']);
      this.activeControl.setValue(this.rowInfos['active']);
      this.isDefaultPromo = !['prime_sponsor','promotion'].includes(this.userInfos['promo_type']);

      this.promoterControl.setValue(this.rowInfos['id_user']);
      this.promoterRateControl.setValue(this.rowInfos['promoter_rate_gain']);

      this.priceProduct = this.rowInfos['price'];
      this.priceRate = this.rowInfos['price_rate_discount'];
      this.promoterRate = this.rowInfos['promoter_rate_gain'];

      this.studentPayment = this.rowInfos['student_price'];
      this.promoterPayout = this.rowInfos['price_cashback'];
      this.promoCode = this.rowInfos['promo_code'];
      this.enovskyGain = this.rowInfos['student_price'] - this.rowInfos['price_cashback'];
    }
  }
  pdatePromotype(){
    this.promoType = this.typeControl.value;
  }
  updateDetail(){
    let idProduct = this.productControl.value ?? 0;
    let product = this.productData.find((element: any) => element.id == idProduct) || {price: 0};
    this.priceProduct = product.price;
    this.priceRate    = Number(this.priceRateControl.value)    || 0;
    this.promoterRate = Number(this.promoterRateControl.value) || 0;

    this.studentPayment = Math.round(product.price * (100 - this.priceRate) / 100);
    this.promoterPayout = Math.round(this.studentPayment * this.promoterRate / 100);
    this.enovskyGain = Math.round(this.studentPayment - this.promoterPayout);
  }

  resetDate(){
    this.beginDateControl.setValue(null);
    this.expirationDateControl.setValue(null);
  }
  updatePromotype(){
    this.promoType = this.typeControl.value;
  }
  applyAction(){
    let promoName = this.promoNameControl.value;
    let idProduct = this.productControl.value;
    let price     = this.priceControl.value;
    let priceRate = this.priceRateControl.value;
    let typePromo = this.typeControl.value;
    let duration  = this.durationControl.value;
    let active = this.activeControl.value;
    let idPromoter = this.promoterControl.value;
    let promoter = this.promoterData.find((el:any)=> idPromoter == el['id']);
    let promoterRate = this.promoterRateControl.value;
    let beginDate: any = new Date(this.beginDateControl.value).toLocaleDateString("fr-FR").replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')+ ' 00:00:00';
    let expirationDate:any = new Date(this.expirationDateControl.value).toLocaleDateString("fr-FR").replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')+ ' 00:00:00';
    beginDate = beginDate.split('-')[0] == '1970' || beginDate.includes('Invalid')? null: beginDate;
    expirationDate = expirationDate.split('-')[0] == '1970' || expirationDate.includes('Invalid')? null: expirationDate;
    this.isDefaultPromo = !['prime_sponsor','promotion'].includes(typePromo);
    
    let data = this.action == 'delete_promo'? {
      action: this.action,
      id_promotion: this.rowInfos['id'],
      user_infos: this.userInfos,
      platform_infos: this.platformInfos,
    }:{
      name: promoName,
      id_product: this.isDefaultPromo? this.rowInfos['id_product']: idProduct,
      id_promotion: this.rowInfos['id'],
      price: price,
      price_rate_discount: priceRate,
      promo_type: this.isDefaultPromo? this.rowInfos['promo_type']: typePromo,
      duration: duration,
      begin_date: beginDate,
      active: active,
      expiration_date: expirationDate,
      id_promoter: idPromoter,
      promoter: promoter,
      promoter_rate_gain: promoterRate,
      send_email: this.sendEmailControl.value,
      user_infos: this.userInfos,
      platform_infos: this.platformInfos,
    }
    if((promoName && typePromo && idProduct) || this.action == 'delete_promo'){
      this.inProgress = true;
      this.apiService.queryData(config.master.ndapi.url + `/enovsky/web/promotion/${this.action}`, data, this.userInfos['access_token']).subscribe((response:any)=>{
        this.updatePromotion.emit(response);
        if(this.action != 'update_promo') this.dialogRef.close();
        this.helper.showToast(response.message); 
        this.inProgress = false;
      })
    }else this.helper.showToast('Not all fields are filled...')
    
  }
  validatePhone(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 1 && input.value !== '+') {
      input.value = '';
      return;
    }
    if (input.value.length > 1) {
      input.value = '+' + input.value.slice(1).replace(/[^0-9]/g, '');
    }
  }
  closeWindow(){
    this.dialogRef.close();
  }
}
